import { AssetAmountInfoType } from './api.portfolio.types';

export type ContributionsResponse = {
  items: ContributionItem[];
};

export type ContributionItem = {
  id: string;
  externalId: string;
  externalType: string;
  asset: AssetAmountInfoType & { amountStringified: string };
  created: string;
  status: string;
  updated: string;
};

export enum ImportContributionFields {
  file = 'file',
}

export type ImportContributionsForm = {
  [ImportContributionFields.file]?: FileList;
};

export type ImportContributionsPayload = {
  [ImportContributionFields.file]: File;
};

export type ImportContributionsResponse = {
  successResultDescription: string;
};

export type ContributionDetailsResponse = {
  items: ContributionDetailItem[];
};

export type ContributionDetailItem = {
  userProfileId: number;
  email: string;
  userProfileType: string;
  contributionType: string;
  created: string;
  fiatEquivalent: number;
  asset: AssetAmountInfoType & { amount: number };
};

export enum TransferStatuses {
  NonProcessed = 'NonProcessed',
  Processing = 'Processing',
  Processed = 'Processed',
}

export type ContributeWalletTransferPayload = {
  walletTransferExternalId: string;
  contributionType: string;
  userProfileId: number;
  amount: string;
  fiatEquivalent?: number;
};
